import styled, { keyframes } from "styled-components";
import { theme } from "src/Utilities";

export const PaymentRedirectOverlay = () => {
    return (
        <Overlay>
            <CircleWindow>
                <SpinnerRing />
                <Message>Sending you to the Payment portal.</Message>
                <SubMessage>Please wait</SubMessage>
            </CircleWindow>
        </Overlay>
    );
};

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;

const CircleWindow = styled.div`
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
    padding: 30px;
    text-align: center;
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const SpinnerRing = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e0e0e0;
    border-top: 4px solid ${theme.colors.highlight};
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    margin-bottom: 20px;
`;

const Message = styled.p`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 6px 0;
    line-height: 1.3;
`;

const SubMessage = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
`;
